// @mui
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';

// ----------------------------------------------------------------------

export default function LogisticsFleetBanner() {
  return (
    <Card
      sx={{
        background: 'linear-gradient(135deg, #25D366 0%, #1ebe5d 100%)',
        color: '#fff',
        px: 2,
      }}
    >
      <CardContent>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ md: 'center' }}
          justifyContent="space-between"
        >
          <div style={{ width: 500 }}>
            <Typography variant="h2" sx={{ fontWeight: 700 }}>
              KARTRAK Fleet
            </Typography>
          </div>

          <div style={{ flexGrow: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, textAlign: 'center' }}>
              Controle total da sua logística!
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, opacity: 1, mt: 1, textAlign: 'center' }}>
              Bem vindo ao Kartrak Fleet! Tenha visibilidade completa da sua frota em tempo real,
              reduza falhas operacionais e tome decisões mais rápidas com dados ao vivo.
            </Typography>
          </div>

          <div style={{ width: '500px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              href="https://wa.me/554891487374?text=Quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20controle%20de%20log%C3%ADstica%20-%20Kartrak%20Fleet"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: '#FFB020',
                color: '#1F2937',
                fontWeight: 700,
                px: 3,
                whiteSpace: 'nowrap',
                '&:hover': {
                  backgroundColor: '#f59e0b',
                },
                height: '50px',
              }}
            >
              👉 Saiba mais
            </Button>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
}
